import { useMutation } from '@tanstack/react-query';

import { organisationApi } from '../../apis/organisation';

export function useUpdateOrganisation() {
  const mutation = useMutation({
    mutationFn: organisationApi.updateOne,
  });

  return mutation;
}

export default useUpdateOrganisation;
